// extracted by mini-css-extract-plugin
export default {"Spinner":"Spinner_Spinner__+Z-E2","Spin":"Spinner_Spin__5gbpI","Logo":"Spinner_Logo__WtsiX"};